@let availableStates = availableStates$ | async; @let availableCounties = availableCounties$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/property-search"></ion-back-button>
    </ion-buttons>
    <ion-title>Search By Owner</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input labelPlacement="stacked" placeholder="John" inputmode="text" type="text" formControlName="firstName">
          <div slot="label">First Name:</div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="Doe"
          inputmode="text"
          [required]="true"
          type="text"
          formControlName="lastName"
        >
          <div slot="label">Last Name:<ion-text color="danger">*</ion-text></div></ion-input
        >
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider>
        <ion-label>Address</ion-label>
      </ion-item-divider>

      @if (availableStates) {
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="state"
        [options]="availableStates"
        placeholder="Select state"
        searchPlaceholder="Search state..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          State:
          <ion-text color="danger">*</ion-text>
        </span>
      </red-searchable-select>
      } @if (availableCounties) {
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="county"
        [options]="availableCounties"
        placeholder="Select county"
        searchPlaceholder="Search county..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          County:
          <ion-text color="danger">*</ion-text>
        </span>
      </red-searchable-select>
      }
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="55555"
          inputmode="tel"
          type="text"
          formControlName="zip"
          [maskito]="zipMask"
          [maskitoElement]="maskPredicate"
          [minlength]="5"
          [maxlength]="5"
        >
          <div slot="label">Zip Code:</div>
        </ion-input>
      </ion-item>
    </ion-list>

    <ion-button class="tw:m-4" expand="block" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty">
      Search<ion-icon slot="start" name="search-outline"></ion-icon>
    </ion-button>
  </form>
</red-page-content>
